import { IconButton, Modal, Separator, Stack, Text } from '@fluentui/react';
import React from 'react';

const CustomModal = (props) => {

    const {
        children = undefined,
        id = undefined,
        isOpen = false,
        onDismiss = () => null,
        title = undefined,
    } = props;

    const styles = {
        header: {
            root: {
                alignItems: "center",
                justifyContent: "space-between"
            }
        },
        icon: { root: { color: "red" } },
        headerText: { root: { color: "red", fontWeight: 700 } },
        modal: { main: { padding: 20 } },
        separator: { root: { selectors: { "::before": { backgroundColor: "red" } } } }
    };

    return <Modal popupProps={{ id }} isOpen={isOpen} onDismiss={onDismiss} styles={styles.modal}>
        <Stack horizontal reversed styles={styles.header}>
            <IconButton iconProps={{ iconName: "Cancel" }} onClick={onDismiss} styles={styles.icon} />
            {!!title && <Text styles={styles.headerText}>{title}</Text>}
        </Stack>
        <Separator styles={styles.separator} />
        {!!children && children}
    </Modal>;

};

export default CustomModal;